import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRedirect, IndexRoute, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { InlineNotification } from 'react-redux-notifications';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'ionicons/dist/css/ionicons-core.min.css';
import 'ionicons/dist/css/ionicons.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';
import Home from './components/Home/Home';
import About from './components/About/About';
import Products from './components/Products/Products';
import Contact from './components/Contact/Contact';
import MainContainer from './containers/Main.js';

import configureStore from './store';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

const router = (
  <Provider store={store}>
    <Router history={history}>
      <Route path='/' component={MainContainer}>
        <IndexRoute component={Home}></IndexRoute>
        <Route path='about' component={About}></Route>
        <Route path='products' component={Products}></Route>
        <Route path='contact' component={Contact}></Route>
      </Route>
    </Router>
  </Provider>
)




ReactDOM.render(
  router,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/